import React, {useState, useEffect} from "react";
import {ListByEssential, ListAllCourses} from "../services/CoursesServices";

export const EssentialContext = React.createContext();

export default function EssentialProvider({children}) {
   const [isLoading, setLoading] = useState({courses: true, heads: true});
   const [allCourse, setAllCourses] = useState([]);
   const [essentialList, setEssentialList] = useState([]);

   const getAllCourses = () => {
      if (essentialList.length > 1) return false;
      ListByEssential()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setEssentialList(data);
         })
         .then((res) => {
            setLoading({...isLoading, courses: false});
         })
         .catch((e) => {
            console.log(e);
         });
   };
   const getAllCoursesList = () => {
      if (allCourse.length > 1) return false;
      ListAllCourses()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setAllCourses(data);
         })
         .then((res) => {
            setLoading({...isLoading, courses: false});
         })
         .catch((e) => {
            console.log(e);
         });
   };

   const removeCourse = (id) => {
      const newList = essentialList.filter((course) => course.idCourse !== id);
      setEssentialList(newList);
   };

   return (
      <EssentialContext.Provider
         value={{
            getAllCourses, // obtener cursos
            essentialList, // lista de cursos
            isLoading, // saber que esá cargando
            removeCourse,
            getAllCoursesList,
            allCourse,
         }}
      >
         {children}
      </EssentialContext.Provider>
   );
}
